/**
 * Resolve the short plan-type badge label ("FSA" / "HSA" / "HRA") from a plan's
 * account name. Ports SFRA's inference (plugin_tpa `models/tpa/customerBalance.js`
 * `getPlanType`, step 2): TPA balance responses often carry a full plan name
 * ("Health Savings Account") rather than the abbreviation, so each type also
 * matches its descriptive keyword. Order matters and mirrors SFRA (FSA → HSA →
 * HRA). Unrecognized names (e.g. "ASIFLEX") pass through unchanged — the badge
 * renders something rather than nothing, and ASIFLEX derives its plan type from
 * exactly this passthrough (SFCC-11421).
 */
export const getPlanType = (accountName: string): string => {
  if (/FSA|Flexible|Spending/i.test(accountName)) return "FSA";
  if (/HSA|Savings/i.test(accountName)) return "HSA";
  if (/HRA|Reimbursement/i.test(accountName)) return "HRA";
  return accountName;
};
